import FeaturedAdsTable from "./page/FeaturedAdsTable";

const FeaturedAds:React.FC =()=>{
    return(
        <>
        <FeaturedAdsTable/>
        </>
    )
};
export default FeaturedAds;